import VSlider from './VSlider'

export default {
  VSlider
}



// WEBPACK FOOTER //
// ./src/components/sliders/index.js